import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-property-usage',
  templateUrl: './property-usage.component.html',
  styleUrls: ['./property-usage.component.scss']
})
export class PropertyUsageComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal: string = '';

  ngOnInit() {
    var modal=this.globals.getModalValue();
    if(undefined!=modal){
      this.section_modal=modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }
}
